/* eslint-disable no-unused-vars */
import styled from 'styled-components';
import { Palette } from 'config';

export const Header = styled.header`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  margin-top: calc(77px + 48px);
  margin-bottom: 48px;
  gap: 8px;
  align-items: center;
`;

export const Title = styled.h2`
  color: ${Palette.PrimaryGray._900};
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 48px;
  letter-spacing: -0.8px;
`;
